import React, { Component } from "react";
import ChartistGraph from 'react-chartist';

// const lineChartData = {
//     labels: [1, 2, 3, 4, 5, 6, 7, 8],
//     series: [
//       [5, 9, 7, 8, 5, 3, 5, 4]
//     ]
//   }
  const lineChartOptions = {
    low: 0,
    showArea: true,
    axisY: {
        offset:90
    }
  }


export class CustomCharts extends Component {
    constructor(props) {
        super(props);
        this.state = {
          lineChartData : {
            labels: ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"],
            series: [
              [6000, 4000, 2000, 5000, 4000, 5600, 10000],
            ]
          }
        };
    }

    render(){
        return(
          <div>
            <ChartistGraph 
            className={'ct-octave'} 
            data={this.props.data} 
            options={lineChartOptions} 
            type={'Line'} />
            <div className="graph-indicator">
            <div class="graph-small-rectangle"></div>
            <div class="">
              <span>{this.props.indicator}</span>
            </div>
            
            </div>
            </div>
        );
    }



}


export default CustomCharts;